type FeatureTextSectionProps = {
  image: string;
  imageAlt: string;
  imageSide: "left" | "right";
  subHeading?: string;
  heading: string;
  description: string;
  linkLabel: string;
  linkHref: string;
  id?: string;
  tinted?: boolean;
};

export default function FeatureTextSection({
  image,
  imageAlt,
  imageSide,
  subHeading,
  heading,
  description,
  linkLabel,
  linkHref,
  id,
  tinted = false,
}: FeatureTextSectionProps) {
  const imageFirst = imageSide === "left";

  return (
    <section id={id} className={`w-full py-14 md:py-20 ${tinted ? "bg-background-100" : "bg-background-50"}`}>
      <div className="max-w-[1200px] mx-auto px-6 md:px-12">
        <div
          className={`flex flex-col ${
            imageFirst ? "lg:flex-row" : "lg:flex-row-reverse"
          } items-center gap-10 lg:gap-16`}
        >
          <div className="w-full lg:w-1/2">
            <div className="w-full aspect-[4/3] overflow-hidden bg-background-200">
              <img
                src={image}
                alt={imageAlt}
                title={`${heading} — Sofia Jewelry`}
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
          <div className="w-full lg:w-1/2">
            <div className="max-w-xl">
              {subHeading && (
                <p className="font-label text-[11px] tracking-[0.28em] uppercase text-foreground-500 mb-3">
                  {subHeading}
                </p>
              )}
              <h2 className="font-heading text-2xl md:text-4xl font-light tracking-[0.12em] uppercase text-foreground-950 mb-6">
                {heading}
              </h2>
              <p className="font-body text-sm md:text-base text-foreground-600 leading-relaxed mb-7">
                {description}
              </p>
              <a
                href={linkHref}
                className="inline-flex items-center gap-2 font-label text-xs tracking-[0.24em] uppercase text-primary-700 border-b border-primary-500 pb-1 hover:text-primary-600 hover:border-primary-600 transition-colors"
              >
                {linkLabel}
                <i className="ri-arrow-right-line text-sm" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}